"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = exports.InputWithIcon = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Input = require("../input/Input");
var _search = require("../../assets/icons/search.svg");
var _remove = require("../../assets/icons/remove.svg");
var _inputWithIconModule = _interopRequireDefault(require("./input-with-icon.module.scss"));
var _Loader = require("../loader/Loader");
var _excluded = ["icon", "className", "containerClassName", "suffix", "onSuffixClick", "onClick", "disabled"],
  _excluded2 = ["value", "onChange", "isLoading"];
var InputWithIcon = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
    className = _ref.className,
    containerClassName = _ref.containerClassName,
    suffix = _ref.suffix,
    onSuffixClick = _ref.onSuffixClick,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", {
    onClick: disabled ? undefined : onClick,
    className: (0, _classnames.default)(_inputWithIconModule.default['input-with-icon'], containerClassName)
  }, icon && /*#__PURE__*/_react.default.createElement("div", {
    className: _inputWithIconModule.default['input-with-icon__icon']
  }, icon), /*#__PURE__*/_react.default.createElement(_Input.Input, Object.assign({}, rest, {
    disabled: disabled,
    className: (0, _classnames.default)(_inputWithIconModule.default['input-with-icon__input'], className, (0, _defineProperty2.default)({}, _inputWithIconModule.default['input-with-icon__input--with-suffix'], !!suffix)),
    ref: ref
  })), suffix && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_inputWithIconModule.default['input-with-icon__suffix'], (0, _defineProperty2.default)({}, _inputWithIconModule.default['input-with-icon__suffix--clickable'], !disabled && onSuffixClick)),
    onClick: disabled ? undefined : onSuffixClick
  }, suffix));
});
exports.InputWithIcon = InputWithIcon;
InputWithIcon.displayName = 'InputWithIcon';
var SearchInput = /*#__PURE__*/_react.default.forwardRef(function (_ref2, ref) {
  var value = _ref2.value,
    onChange = _ref2.onChange,
    isLoading = _ref2.isLoading,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  var onClearClick = function onClearClick() {
    return onChange({
      currentTarget: {
        value: ''
      },
      target: {
        value: ''
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement(InputWithIcon, Object.assign({}, rest, {
    icon: /*#__PURE__*/_react.default.createElement(_search.ReactComponent, null),
    onChange: onChange,
    value: value,
    suffix: isLoading ? /*#__PURE__*/_react.default.createElement(_Loader.Loader, {
      small: true,
      "data-testid": "loader"
    }) : value && /*#__PURE__*/_react.default.createElement(_remove.ReactComponent, {
      "data-testid": "clear-icon"
    }),
    onSuffixClick: isLoading ? undefined : onClearClick,
    ref: ref
  }));
});
exports.SearchInput = SearchInput;
SearchInput.displayName = 'SearchInput';